// funder service
export default {
    install: (Vue) => {
      //private
      const route = process.env.VUE_APP_API_BASE_URL + '/api/funder-impalas';
  
      //public
      Vue.$funderService = {
        find(params) {
          return Vue.axios.get(route, {
            params: params
          });
        }
      };
    }
  };
//   //example of use
//   var grants = await Vue.$grantService.find({
//     name: 'test'
//   });